module.exports = __webpack_public_path__ + "img/team3.c89b2ea5.jpg";